import { ItemListElements } from 'next-seo/lib/types'
import getConfig from 'next/config'

import { linkBuilder, Translator } from '@/components/Link/linkBuilder'
import { CateCity } from '@/context/Cities'
import { ListingCate } from '@/page-commons/listingBySlug'
import { Zone } from '@/types/cities'
import getTranslatedTitle from '@/utils/get-translated-title'

type Depth = 'listings' | 'listingDetail'

type Props = {
  cities: CateCity[]
  city?: CateCity
  depth: Depth
  language: Locale
  property?: ListingCate
  t: (v: string) => string
  zone?: Zone
}

// FIXME: Add types
const getItemHomePage = (publicRuntimeConfig, t: Translator, language: Locale) => ({
  item: publicRuntimeConfig.lisaWebsite + linkBuilder.housesForSale.url(language),
  name: t('common:footer-our-properties-label'),
  position: 1,
})

const getItemZone = (publicRuntimeConfig, language: Locale, cities: CateCity[], cityValue: string, zone: Zone) =>
  zone
    ? {
        item: `${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingByCity.url(
          language,
          cities,
          cityValue
        )}${zone.slug.split('/')[2].concat('/')}`,
        name: zone.label,
        position: 3,
      }
    : null

const getItemCity = (
  publicRuntimeConfig,
  language: Locale,
  cities: CateCity[],
  translatedCityName: string,
  cityValue: string
) => {
  return cityValue
    ? {
        item: `${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingByCity.url(language, cities, cityValue)}`,
        name: translatedCityName,
        position: 2,
      }
    : null
}

const getItemDetail = (publicRuntimeConfig, language: Locale, cities: CateCity[], property: ListingCate) => ({
  item: `${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingDetail.url(language, property.slug)}`,

  name: property ? getTranslatedTitle(property.detail?.titles, language) : '',
  position: 4,
})

export const getBreadcrumbList = ({ cities, city, depth, language, property, t, zone }: Props): ItemListElements[] => {
  const { publicRuntimeConfig } = getConfig()

  const itemHomePage = getItemHomePage(publicRuntimeConfig, t, language)

  switch (depth) {
    case 'listings':
      return [
        itemHomePage,
        getItemCity(publicRuntimeConfig, language, cities, city.translatedCityName, city.slug),
        getItemZone(publicRuntimeConfig, language, cities, city.slug, zone || property?.detail.zone),
      ].filter(Boolean)

    case 'listingDetail':
      const areZoneEnabledForCity = city.city_zones.length > 0
      return [
        itemHomePage,
        getItemCity(publicRuntimeConfig, language, cities, city.translatedCityName, city.slug),
        getItemZone(publicRuntimeConfig, language, cities, city.slug, areZoneEnabledForCity && property?.detail.zone),
        getItemDetail(publicRuntimeConfig, language, cities, property),
      ].filter(Boolean)
  }
}
